import React from 'react';
import {useDispatch} from "react-redux";
import BaseModal from "./BaseModal";
import Button from "../../../../core/Button/Button";
import {useTranslation} from "react-i18next";
import {closeRoom, closeRoomCloseModal} from "../../../../redux/actions/rooms/actions";

function LogoutModal({room}) {
    const dispatch = useDispatch();
    const {t} =useTranslation();

    return (
        <BaseModal>
            <p className="modal__join--text">{t("modals.logout.text")}</p>
            <div className="modal__join--buttons">
                <Button
                    text={t('modals.buttons.yes')}
                    type="green"
                    onClick={() =>  dispatch(closeRoom({roomId: room.roomId}))}
                />
                <Button
                    text={t('modals.buttons.no')}
                    type="red"
                    onClick={() => dispatch(closeRoomCloseModal({roomId: room.roomId}))}
                />
            </div>
        </BaseModal>
    )
}

export default LogoutModal
